<!--
    Styles
-->

<style scoped>


    /* main */

    .marker {
        width: 300px;
        z-index: 1;
    }
    .marker .container {
        position: relative; /* overlap arrow */
        width: inherit;
        min-height: 150px;
    }
    .marker .container.active {
        min-height: 264px;
    }


    /* elements */

    .marker .spinner {
        width: 32px;
        height: 32px;
    }
    .marker .error {
        white-space: nowrap;
    }
    .marker .image {
        flex-shrink: 0;
        width: inherit;
        height: 132px;
        border-radius: 3px 3px 0 0;
    }


    /* content */

    .marker .content {
        padding: 10px 10px 0 10px;
        flex-basis: auto;
        overflow: auto;
    }
    .marker .content p {
        margin-top: 2px;
    }
    .marker .content .date {
        margin-bottom: 10px;
    }
    .marker .content .deal {
        margin-bottom: 4px;
        overflow: hidden;
    }
    .marker .content .deal:last-child {
        margin-bottom: 10px; /* IE ignores content padding-bottom */
    }


</style>



<!--
    Template
-->

<template>
    <div class="marker arrow-bottom u-row u-stretch" @wheel.stop>
        <div class="container u-col" :style="{maxHeight: maxHeight + 'px'}" :class="{active: data}">

            <ui-spinner class="spinner u-center" v-show="request" />

            <div class="error u-center cl-gray t16" v-show="error">
                Could not load data
            </div>

            <ui-image v-show="src" class="image" ref="image" :src="src" />

            <div class="content u-flex" v-if="data">
                <a class="t14 w7 cl-blue">{{ data.name }}</a>
                <p class="t11">{{ data.address }}</p>
                <p class="t11 date">{{ data.builtAt | date }}築</p>
                <item-deal class="deal t11" v-for="deal in data.deals" :key="deal.id" :deal="deal" @select="select({deal, building: data})" />
            </div>

        </div>
    </div>
</template>



<!--
    Scripts
-->

<script>

    import {mapGetters, mapActions} from 'vuex'
    import API from '@/common/modules/api'
    import maps from '@/common/modules/maps'
    import {date} from '@/common/helpers/parse'
    import uiSpinner from '@/components/shared/ui/spinner.vue'
    import uiImage from '@/components/shared/ui/image.vue'
    import itemDeal from '@/components/dashboard/items/deal.vue'

    export default {

        components: {
            uiSpinner,
            uiImage,
            itemDeal
        },

        props: [
            'id',
            'maxHeight'
        ],

        data () {
            return {
                data: null,
                src: null,
                error: false,
                request: false
            }
        },

        computed: {

            ...mapGetters('dashboard', [
                'building'
            ])

        },

        filters: {
            date
        },

        methods: {

            ...mapActions('search', [
                'select'
            ]),

            render (building) {
                this.data = building;
                this.src = maps.image(building, this.$refs.image.$el);
            },

            loaded (response) {
                const building = response.data.buildings[0];
                if (!building) throw new Error();
                else this.render(building);
            },

            abort () {
                this.request && API.abort(this.request);
            },

            reset () {
                this.data = null;
                this.src = null;
                this.error = false;
                this.request = false;
            },

            update () {
                this.abort();
                this.reset();
                const building = this.building(this.id);
                if (building) return this.render(building);
                this.request = API('buildings', {id: this.id});
                this.request
                    .then(this.loaded)
                    .catch(() => this.error = true)
                    .finally(() => this.request = false);
            }

        },


        watch: {

            id () {
                this.update();
            }

        },

        mounted () {
            this.update();
        },

        destroyed () {
            this.abort();
        }


    }

</script>

